<template>
  <select
    class="native-select"
    :value="modelValue"
    :disabled="disabled"
    :style="style"
    @change="handleChange"
  >
    <option v-if="placeholder" disabled value="">{{ placeholder }}</option>
    <option v-if="clearable" value="">清空选择</option>
    <slot />
  </select>
</template>

<script setup lang="ts">
import type { StyleValue } from "vue";

defineOptions({ inheritAttrs: false });

withDefaults(
  defineProps<{
    modelValue?: string | number;
    disabled?: boolean;
    placeholder?: string;
    clearable?: boolean;
    style?: StyleValue;
  }>(),
  { modelValue: "" },
);

const emit = defineEmits<{
  (event: "update:modelValue", value: string | number): void;
  (event: "change", value: string | number): void;
}>();

const handleChange = (event: Event) => {
  const select = event.target as HTMLSelectElement;
  const selected = select.selectedOptions[0] as HTMLOptionElement & {
    _value?: string | number;
  };
  const value = selected?._value ?? selected?.value ?? "";
  emit("update:modelValue", value);
  emit("change", value);
};
</script>

<style scoped>
.native-select {
  min-height: 38px;
  padding: 7px 32px 7px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  background: #fff;
  color: #263238;
  font: inherit;
}
</style>
